const CONSTANTS = {};
module.exports = CONSTANTS;

CONSTANTS.BACKOFFICE_ROLES = {
    ADMIN: 'admin', // access to everything (the only role that allows to view/edit/create backoffice users)
    RESERVATIONS_MANAGER: 'reservations_manager', // access to reservations data (reservations management page, reservations view/edit/create, csvs, etc), no access to users/companies data
    ACCOUNT_MANAGER: 'account_manager', // access to users/companies data (view/edit/create), no access to reservations data
    MATCHER: 'matcher', // access to room mapping functionalities
    ROOM_TRADER: 'room_trader', // access to repricer functionalities
    FINANCE_MANAGER: 'finance_manager', // access to credit line and payment due dates
    TEMPLATE_MANAGER: 'template_manager', // access to create/edit templates
    AUTH0_IMPERSONATOR_LOGIN: 'auth0_impersonator_login', // can login through auth0 as another user to arbitrip app
    SALES: 'sales', // access to sales dashboard and leaderboard
};
